import React from "react";
import {
  FbTypeography,
  FbBreadcrumbs,
  FbmakeStyles,
} from "@flexibees/core";
import { withRouter } from "react-router-dom";

const useStyles = FbmakeStyles({
  root: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "13px",
    color: "#000000",
    textTransform: "capitalize",
    cursor: "pointer",
  },
  lastItem: {
    fontSize: "13px",
    textTransform: "capitalize",
  },
});

const getBreadcrumbLabel = (item, isLastItem = false) => {
  const labels = {
    projects: "All Projects",
    update: "Update Project Details",
    assign: "Assign Recruiter",
    view: "Recruitment Workflow",
    workflow: "Recruitment Workflow",
    details: "Candidate Details",
    candidates: "All Candidates",
    "project-launches": "Project Launches",
  };

  if (item === "detail") {
    return isLastItem ? "Project Details" : "Launch Details";
  }

  return labels[item] || item;
};

const isInvalidRoute = (route) =>
  [
    "update",
    "view",
    "assign",
    "detail",
    "details",
    "workflow",
  ].includes(route);

const hasNumber = (value) => /\d/.test(value);

const BreadCrumbs = (props) => {
  const { location, history } = props;
  const classes = useStyles();

  const pathNames = location.pathname
    .split("/")
    .filter(Boolean);

  const handleRoute = (route) => {
    if (isInvalidRoute(route)) return;

    history.push(`/finance/${route}`);
  };

  return (
    <FbBreadcrumbs separator=">">
      {pathNames.map((item, index) => {
        const lastItem =
          index === pathNames.length - 1;

        if (
          hasNumber(item) ||
          item === "recruiter"
        ) {
          return null;
        }

        const label = getBreadcrumbLabel(
          item,
          lastItem
        );

        return lastItem ? (
          <FbTypeography
            key={item}
            className={classes.lastItem}
          >
            {label}
          </FbTypeography>
        ) : (
          <FbTypeography
            key={item}
            className={classes.root}
            onClick={() => handleRoute(item)}
          >
            {label}
          </FbTypeography>
        );
      })}
    </FbBreadcrumbs>
  );
};

export default withRouter(BreadCrumbs);